import { CircleSpinner } from './CircleSpinner'

/**
 *  @group UI Components
 */
export const Loading = ({ dark = false }: { dark?: boolean }) => {
  return (
    <div
      className={`flex size-full grow items-center justify-center ${dark ? 'bg-black opacity-20' : ''}`}
    >
      <CircleSpinner />
    </div>
  )
}
